const splitIntoSentences = (text) => {
    if (!text.trim().endsWith('.')) text += '.';
    const sentenceRegex = /[^.!?]+[.!?]+[\])'"`’”]*/g;
    return text.match(sentenceRegex) || [];
};
  
const urlParam = key => new URLSearchParams(window.location.search).get(key);

const cleanTextForSpeaking = (text) => {
    return text.replaceAll('*', '');
};

export { splitIntoSentences, urlParam, cleanTextForSpeaking };